import React from 'react';
import img from '../../assets/images/404img.jpg';
const NotFound = () => {
    return (
        <div>
            <img src={img} alt="" />
        </div>
    );
};

export default NotFound;